import axios from '../../helpers/axios-setup';

export const getSingleTC = (id: number | string) => axios.get(`/test-cases/${id}`);
